import { EXIT_DATE_ALIAS } from 'common/constants/allocations';
import { GRID_DATE, NUMBER } from 'common/constants/gridType';
import { getEnterpriseValueFormula, getEquityValueFormula } from 'common/formulas/math.js/ENTERPRISE_AND_EQUITY_VALUE';
import { GridType } from 'common/types/scalarSpreadsheet';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import {
  contentClass, EXIT_ENTERPRISE_VALUE_ALIAS,
  EXIT_EQUITY_ALIAS,
  FIRM_TOTAL_EXIT_PROCEEDS_ALIAS, LESS_DEBT_ALIAS, PLUS_CASH_ALIAS,
} from 'pages/Waterfall/SpreadsheetConfig/constants';
import { InputSheetParserParams } from '../InputSheetRowConfig/InputSheetRowConfig.types';

const InputSheetParser = ({ rowConfig }: InputSheetParserParams) => {
  const cells: Record<string, ICell> = {};
  let enterpriseValueCell: ICell | undefined;
  let equityValueCell: ICell | undefined;
  let plusCashCell: ICell | undefined;
  let lessDebtCell: ICell | undefined;

  rowConfig.forEach((row, index) => {
    // calculate alphanumeric value for the index
    const columnLegend = 'A';
    const valueColumnLegend = 'B';
    const key = `${columnLegend}${index + 1}`;
    const valueKey = `${valueColumnLegend}${index + 1}`;
    let gridType;
    if ([PLUS_CASH_ALIAS, LESS_DEBT_ALIAS, EXIT_ENTERPRISE_VALUE_ALIAS, EXIT_EQUITY_ALIAS].includes(row.alias)) {
      gridType = NUMBER;
    } else if (row.alias === EXIT_DATE_ALIAS) {
      gridType = GRID_DATE;
    }
    cells[key] = {
      key,
      columnLegend,
      alias: row.headerAlias || '',
      value: row.headerValue,
      valueViewer: undefined,
      dataEditor: undefined,
      readOnly: true,
      className: 'row-label',
      expr: undefined,
    };
    const valueCell = {
      value: row.value,
      key: valueKey,
      columnLegend: valueColumnLegend,
      className: contentClass,
      alias: row.alias,
      readOnly: [FIRM_TOTAL_EXIT_PROCEEDS_ALIAS, LESS_DEBT_ALIAS, PLUS_CASH_ALIAS].includes(row.alias),
      valueViewer: row.valueViewer,
      dataEditor: row.dataEditor,
      format: row.format,
      gridType: row.alias === FIRM_TOTAL_EXIT_PROCEEDS_ALIAS ? 'number' : (gridType as GridType),
      expr: row.alias === FIRM_TOTAL_EXIT_PROCEEDS_ALIAS ? row.expr : undefined,
    };
    cells[valueKey] = valueCell;
    switch (row.alias) {
      case EXIT_ENTERPRISE_VALUE_ALIAS:
        enterpriseValueCell = valueCell;
        break;
      case EXIT_EQUITY_ALIAS:
        equityValueCell = valueCell;
        break;
      case PLUS_CASH_ALIAS:
        plusCashCell = valueCell;
        break;
      case LESS_DEBT_ALIAS:
        lessDebtCell = valueCell;
        break;
      default:
        break;
    }
  });
  if (enterpriseValueCell?.key && equityValueCell?.key && plusCashCell?.key && lessDebtCell?.key) {
    if (enterpriseValueCell.value && !equityValueCell.value) {
      equityValueCell.expr = `=${getEquityValueFormula(enterpriseValueCell.key, plusCashCell.key, lessDebtCell.key)}`;
    }
    if (equityValueCell.value && !enterpriseValueCell.value) {
      enterpriseValueCell.expr =  `=${getEnterpriseValueFormula(equityValueCell.key, plusCashCell.key, lessDebtCell.key)}`;
    }
  }
  return cells;
};

export default InputSheetParser;
